// Utilidades para abrir archivos protegidos (/uploads) que exigen sesión iniciada.
// Un enlace o un <iframe> directo no puede enviar el token, así que el archivo se
// descarga con fetch (con el token) y se muestra desde una URL temporal en el navegador.

export async function obtenerUrlProtegida(url) {
    const token = localStorage.getItem('access_token');

    const respuesta = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    if (!respuesta.ok) {
        throw new Error(
            respuesta.status === 401
                ? 'Tu sesión expiró. Inicia sesión de nuevo.'
                : 'No se pudo abrir el archivo.'
        );
    }

    const blob = await respuesta.blob();
    return URL.createObjectURL(blob);
}

// Abre el archivo en una pestaña nueva. La pestaña se abre primero para que el
// navegador no bloquee la ventana emergente mientras se descarga el archivo.
export async function abrirArchivoProtegido(url) {
    const ventana = window.open('', '_blank');

    try {
        const urlTemporal = await obtenerUrlProtegida(url);

        if (ventana) {
            ventana.location.href = urlTemporal;
        } else {
            window.open(urlTemporal, '_blank');
        }

        setTimeout(() => URL.revokeObjectURL(urlTemporal), 60000);
    } catch (error) {
        if (ventana) ventana.close();
        throw error;
    }
}
